import type { FC } from 'react';
import type { IOrderServices } from '~/processes/providers/authorization/entity';
import { getServiceSize } from './lib/getServiceSize';
import classes from './services.module.scss';

interface IProps {
    service: Pick<IOrderServices, 'addons' | 'number_of_units' | 'unitname'>;
    defaultUnitName: string;
}

const ServiceAmount: FC<IProps> = ({
    service,
    defaultUnitName,
}) => {
    const unitName = service.unitname || defaultUnitName;
    const serviceSize = getServiceSize(service.addons);

    return (
        <span className={classes.amount}>
            <span>
                {service.number_of_units} { unitName }
            </span>
            {serviceSize && (
                <span className={classes.itemSize}>
                    ({serviceSize})
                </span>
            )}
        </span>
    );
};

export default ServiceAmount;
